import * as React from 'react'
import {
  Show,
  SimpleShowLayout,
  DateField,
  TextField,
  NumberField,
  TopToolbar,
} from 'react-admin'

import RefundButton from './RefundButton'

const PaymentShowActions = ({ permissions, basePath, data }) => {
  const permissionsJson = permissions && JSON.parse(permissions)
  const isAdmin = permissionsJson?.value?.includes('Administrator')
  return (
    <>
      <TopToolbar>{isAdmin && <RefundButton record={data} />}</TopToolbar>
    </>
  )
}

export const PaymentShow = ({ permissions, ...props }) => (
  <Show actions={<PaymentShowActions permissions={permissions} />} {...props}>
    <SimpleShowLayout>
      <DateField source="created" />
      <DateField source="updated" />
      <TextField source="amount" />
      <TextField source="status" />
      <TextField source="transaction_id" />
      <TextField source="type" />
      <NumberField source="participantID" label={'Gebruiker ID'} />
    </SimpleShowLayout>
  </Show>
)
